<template>
  <a class="refresh" href="#" @click.prevent="reload()">
    <span class="material-icons">refresh</span>
  </a>
</template>

<script>
export default {
  name: "Reload",
  methods: {
    reload() {
      this.$vs.loading();
      window.location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
.refresh {
  font-size: 30px;
  padding-left: 13px;
  color: #373737 !important;
  display: none;

  @media (display-mode: standalone) {
    display: flex;
  }
}
</style>
